import { Mutations } from 'vuex-smart-module';
import OrganizationsSharedState from './state';

export default class OrganizationsSharedMutations extends Mutations<OrganizationsSharedState> {
}
